import { render } from "./formDisplay.vue?vue&type=template&id=033f2da9&ts=true"
import script from "./formDisplay.vue?vue&type=script&lang=ts"
export * from "./formDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__